import React from 'react';

export default function ExportCSV({ data, fileName, headers, mapRow }) {
    const handleExport = () => {
        if (!data || !data.length) return;

        const rows = [
            headers,
            ...data.map(mapRow),
        ];

        const csvContent = rows
            .map((row) => row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(','))
            .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName || 'relatorio'}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    return (
        <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleExport}
        >
            Exportar CSV
        </button>
    );
}
